// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"472":"82143048","972":"c2c2de54"}[chunkId] + ".chunk.css";
};